module.exports = __webpack_public_path__ + "static/media/computers_icon.d25ffc93.png";